import React from "react";

const ExpertOversightSection =() =>{
    return(
        <>
      <section className="container  text-center pb-2 mt-n5 pt-n5 mt-md-4 pt-md-4 mt-lg-5 pt-lg-5">
          <h2 className="h1 pt-0 pt-md-5">Expert Oversight, Delivered Digitally</h2>
          <div className="row justify-content-center mb-md-2 mb-lg-5">
            <div className="col-md-10">
              <p className="fs-lg pb-2 pt-4 text-center">Orbix connects you with an elite network of independent, certified Level III auditors—each bringing extensive field experience and proven technical expertise directly to your projects.</p>
              <p className="fs-lg pb-2  text-center">Available on-demand through our platform, they provide the crucial real-time oversight needed for complex NDT operations.</p>
              <p className="fs-lg  text-center">No more disconnected SharePoints, FTP servers, or cobbled-together tools. Orbix unifies communication, data flow, and oversight in a secure, centralized platform—while powering AI-driven decisions by connecting every relevant data point across your operation.</p>
            </div>
          </div>
          
        </section>
       

        </>
    )

}

export default ExpertOversightSection;